// ============================================================================
// FILE: src/modules/ppe/pages/uploads/UploadFrameworkPage.js
// MODULE: PPE
//
// PURPOSE:
// Temporary page for testing the Generic Upload Framework.
//
// RESPONSIBILITIES:
// - Host the Generic Upload Drawer.
// - Control drawer open/close state for framework testing.
// ============================================================================
//
// AUTHOR:
// DizyPro ERP Development Team
// ============================================================================

import React, { useState } from "react";

import UploadDrawer from "../../../uploads/components/UploadDrawer";

const UploadFrameworkPage = () => {

    // =========================================================================
    // Drawer State
    // =========================================================================

    const [uploadOpen, setUploadOpen] = useState(true);

    // =========================================================================
    // Render
    // =========================================================================

    return (
        <>
            {!uploadOpen && (
                <div style={{ padding: "24px" }}>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => setUploadOpen(true)}
                    >
                        Open Generic Upload
                    </button>
                </div>
            )}

            <UploadDrawer
                open={uploadOpen}
                onClose={() => setUploadOpen(false)}
                moduleCode="RAW_MATERIAL"
                moduleName="Raw Material"
                entityCode="ENGINEERING_SKU"
                entityName="Engineering SKU"
                title="Generic Upload Framework"
                description="Upload Engineering SKU Master"
                uploadTypes={[
                    {
                        value: "ENGINEERING_SKU",
                        label: "Engineering SKU"
                    },
                    {
                        value: "MANUFACTURER_SKU",
                        label: "Manufacturer SKU"
                    }
                ]}
            />
        </>
    );
};

export default UploadFrameworkPage;